// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"22d850ae","673":"0fb96302","767":"25444446"}[chunkId] + ".chunk.js";
};